<template>
  <div :class="[_.wrapper, '__image_like__']">
    <video
      ref="video"
      :class="_.video"
      :src="src"
      :poster="cover"
      x5-video-player-type="h5"
      preload="auto"
      controls="controls"
      @pause="isPlay = false"
      @play="isPlay = true"
    />
    <img v-if="!isPlay" :src="cover" :class="_.cover" />
    <img v-if="!isPlay" :src="playIcon" :class="_.play" @click="play" />
  </div>
</template>

<script>
  import inViewport from 'vue-in-viewport-mixin'
  import Vue from 'vue'
  import { buildOssVideoCoverUrl } from '@/utils'

  export default Vue.extend({
    mixins: [inViewport],

    props: {
      src: {
        type: String,
        required: true,
      },
      visible: {
        type: Boolean,
        default: true,
      },
      playIcon: {
        type: String,
        default: require('./images/播放.png'),
      },
    },

    data: () => ({
      isPlay: false,
    }),

    computed: {
      cover() {
        return buildOssVideoCoverUrl(this.src)
      },
    },

    watch: {
      ['inViewport.now'](visible) {
        if (!visible) {
          this.pause()
        }
      },
      visible(visible) {
        if (!visible) {
          this.pause()
        }
      },
    },

    methods: {
      play() {
        this.$refs.video.play()
      },
      pause() {
        this.$refs.video.pause()
      },
    },
  })
</script>

<style lang="scss" module>
  .wrapper {
    position: relative;
    font-size: 0;
    user-select: none;
    -webkit-touch-callout: none;

    .video {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .cover {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
      z-index: 1;
    }

    .play {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 41px;
      height: 41px;
      z-index: 2;
    }
  }
</style>
